import "./DropdownSelect.scss"
import React from "react"
import { Select, MenuItem, InputAdornment, FormControl } from "@mui/material"

type DropdownSelectProps = {
  value: string
  onChange: (event: any) => void
  items: Array<{ label: string; value: string }>
  startIcon?: string
  className?: string
}

const DropdownSelect: React.FC<DropdownSelectProps> = ({
  value,
  onChange,
  items,
  startIcon,
  className,
}) => {
  return (
    <FormControl
      className={"dropdown " + className}
      variant="outlined"
      fullWidth
    >
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        startAdornment={
          startIcon && (
            <InputAdornment position="start">
              <img src={startIcon} className="icon" alt="icon" />
            </InputAdornment>
          )
        }
      >
        {items.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default DropdownSelect
